module.exports = __webpack_public_path__ + "static/media/ellipsis-h-alt.9ef31858.svg";